import React from 'react';

export const LabelField = ({name, info, rows, defaultValue, onChange, prop}) => {
	var change = onChange ? ev => onChange(prop, ev.target.value): null;
	return (
		<div className="label-field">
			<label>{name} <span>{info}</span></label>
			<textarea onChange={change} rows={rows} defaultValue={defaultValue}></textarea>
		</div>
	);
}

LabelField.defaultProps = { rows: 2 };

export class ImageField extends React.Component {
	constructor(props){
		super(props);
		this.state = { fileName: props.defaultValue ? props.defaultValue.name : null };
	}

	onChange = ev => {
		var { onChange, prop } = this.props;
		var files = ev.target.files;
		if (!files || !files.length === 0) return;
		var file = files[0];
		var reader = new FileReader();
		reader.onload = _ => {
			var dataURL = reader.result;
			onChange && onChange(prop, file, dataURL);
		};
		reader.readAsDataURL(file);
		this.setState({fileName: file.name});
	};

	handleClick = _ => this._fileField.click();
	render(){
		var { fileName } = this.state;
		var { name, info, showLabel } = this.props;
		return (
			<div className="label-field">
				{showLabel && <label>{name} <span>{info}</span></label>}
				<div onClick={this.handleClick}>
					<input ref={r => this._fileField = r} onChange={this.onChange} type="file" accept="image/*" />
					<input type="text" readOnly disabled value={fileName || 'Seleccione una imagen'} />
					<i className="icon-image"></i>
				</div>
			</div>
		);
	}
}

ImageField.defaultProps = {
	defaultValue: {},
	showLabel: true
}
